import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'edenred-ui';

import { BenefitTypeIcon } from '../BenefitTypeIcon';

import { BenfitTypeName } from './BenefitSettingsModal.styles';

type OwnProps = {
  benefitName: string;
};

export const BenefitHeader = ({ benefitName }: OwnProps) => {
  const { t } = useTranslation();
  const name = t(
    `components.manage_benefits.new.benefits.${benefitName.toLowerCase()}`
  );
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <BenfitTypeName>
        {t(`components.manage_benefits.new.settings_for_benefit`, {
          benefit: name
        })}
      </BenfitTypeName>
      <Box
        width={32}
        height={32}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <BenefitTypeIcon benefit={benefitName?.toLowerCase()} />
      </Box>
    </Box>
  );
};
